import { Drawer, Box, IconButton, Typography, List, ListItem, ListItemButton, ListItemText, Button } from '@mui/material';
import { Logo, Close as CloseIcon, RocketLaunch as RocketLaunchIcon } from '../icons';
import { landingColors, landingFont } from './landingTheme';
import { NAV_ITEMS } from './landingContent';

export default function MobileNavDrawer({ open, onClose, isAuthenticated, onNavigate, onScrollToSection }) {
  const authed = typeof isAuthenticated === 'function' && isAuthenticated();

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: { width: '82%', maxWidth: 340, backgroundColor: landingColors.night, color: '#fff', fontFamily: landingFont },
      }}
    >
      <Box sx={{ p: 3 }}>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <IconButton onClick={onClose} sx={{ color: '#fff' }} aria-label="Close menu">
            <CloseIcon />
          </IconButton>
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 4 }}>
          <Logo size={38} variant="white" />
          <Typography sx={{ fontFamily: landingFont, fontWeight: 800, fontSize: '1.3rem' }}>merchQRy</Typography>
        </Box>

        <List aria-label="Mobile navigation">
          {NAV_ITEMS.map((item) => (
            <ListItem key={item.id} disablePadding sx={{ mb: 0.5 }}>
              <ListItemButton
                onClick={() => onScrollToSection(item.id)}
                sx={{ borderRadius: '12px', py: 1.25, '&:hover': { backgroundColor: 'rgba(255,255,255,0.08)' } }}
              >
                <ListItemText
                  primary={item.label}
                  primaryTypographyProps={{ fontFamily: landingFont, fontWeight: 600, fontSize: '1.05rem' }}
                />
              </ListItemButton>
            </ListItem>
          ))}
        </List>

        <Box sx={{ mt: 4, display: 'flex', flexDirection: 'column', gap: 1.5 }}>
          <Button
            onClick={() => onNavigate(authed ? '/admin' : '/login')}
            variant="outlined"
            fullWidth
            sx={{
              fontFamily: landingFont,
              borderColor: 'rgba(255,255,255,0.4)',
              color: '#fff',
              fontWeight: 600,
              py: 1.25,
              borderRadius: '12px',
              textTransform: 'none',
              '&:hover': { borderColor: '#fff', backgroundColor: 'rgba(255,255,255,0.08)' },
            }}
          >
            {authed ? 'Dashboard' : 'Login'}
          </Button>
          <Button
            onClick={() => onNavigate('/register')}
            variant="contained"
            disableElevation
            fullWidth
            startIcon={<RocketLaunchIcon />}
            sx={{
              fontFamily: landingFont,
              backgroundColor: landingColors.indigo,
              fontWeight: 700,
              py: 1.25,
              borderRadius: '12px',
              textTransform: 'none',
              '&:hover': { backgroundColor: landingColors.indigoStrong },
            }}
          >
            Get Started Free
          </Button>
        </Box>
      </Box>
    </Drawer>
  );
}
